<template>
  <v-app id="onInpt">

    <defNavBar title="Ares - Sales partner" :actions="inpt.action_items" :home="true" :attms="inpt.attm_aant" :notts="inpt.nott_aant" @actionClick="actionClick"/>

    <v-main>
      <v-container fluid>
        <v-row>
          <v-col cols="6" class="px-1">
            <!-- Links -->
            <v-container>
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-form ref="inptCard1" v-model="inptCard1Valid">
                      <v-card-title> Sales partner: {{ inpt.inpt_code }} 
                        <v-avatar class="mx-5" color="red" size=30 @click="getIper('Error')" v-show="iperErrorsExist">{{ inpt.iperNumberOfErrors }}</v-avatar>
                        <v-avatar class="mx-5" color="orange" size=30 @click="getIper('Warning')" v-show="iperWarningsExist">{{ inpt.iperNumberOfWarnings }}</v-avatar>
                         <iper ref="iper"></iper>
                      </v-card-title>
                      <v-row no-gutters>
                        <v-col cols="4" class="px-1">
                          <v-text-field
                            v-model="inpt.inpt_naam"
                            :rules="inpt_naamRules"
                            label="Commercial company name"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="5" class="px-1">
                          <v-text-field
                            v-model="inpt.inpt_passwd"
                            :rules="inpt_passwdRules"
                            label="Password"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col
                          v-if="inpt.inpt_email > ''"
                          cols="2"
                          class="mx-15"
                        >
                          <v-btn
                            class="primary ma-2"
                            small
                            @click="loginInfo(inpt.inpt_encrid)"
                            >Login Host website MyVilla</v-btn
                          >
                        </v-col>
                      </v-row>
                     
                      <v-row no-gutters>

                        <v-col cols="3" class="px-1">
                          <inpt_type_select label="Sales partner type" :value="inpt.inpt_type" field="inpt_type" @updateData="updateData"/> 
                        </v-col> 
                        <v-col cols="3" class="px-1">
                          <inpt_status_select label="Sales partner status" :value="inpt.inpt_status" field="inpt_status" @updateData="updateData"/> 
                        </v-col>                                                
                        <v-col cols="2" class="px-1">
                          <v-select
                            v-model="inpt.taal_code"
                            :items="taal_codeKeuzes"
                            label="Language"
                            dense
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="7" class="px-1">
                          <v-text-field
                            v-model="inpt.inpt_adres"
                            label="Address Street / Housenumber"
                            dense
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="2" class="px-1">
                          <v-text-field
                            v-model="inpt.inpt_postcode"
                            label="Postcal code"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="5" class="px-1">
                          <v-text-field
                            v-model="inpt.inpt_plaats"
                            label="City"
                            dense
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="4" class="px-1">
                          <v-select
                            v-model="inpt.land_code"
                            :items="land_codeKeuzes"
                            item-value="land_code"
                            item-text="landtaal_oms"
                            label="Country"
                            menu-props="auto"
                            dense
                          ></v-select>
                        </v-col>
                      </v-row>
                     
                      
                      <v-row no-gutters>
                        <v-col cols="4" class="px-1">
                           <v-text-field v-model="inpt.inpt_tel1_vcs" label="Tel 1 Number" dense></v-text-field>
                         </v-col>  
                         <v-col cols="4" class="px-1">
                           <v-text-field v-model="inpt.inpt_tel1_type" label="Tel 1 Type" dense></v-text-field>
                         </v-col> 

                        <v-col cols="3" class="px-1">
                          <v-text-field
                            v-model="inpt.inpt_tel1_oms"
                            label="Remark"
                            placeholder="."
                            dense
                          ></v-text-field>
                        </v-col>
                      </v-row>



                      <v-row no-gutters>
                        <v-col cols="4" class="px-1">
                           <v-text-field v-model="inpt.inpt_tel2_vcs" label="Tel 2 Number" dense></v-text-field>
                         </v-col>  
                         <v-col cols="4" class="px-1">
                           <v-text-field v-model="inpt.inpt_tel2_type" label="Tel 2 Type" dense></v-text-field>
                         </v-col> 

                        
                        <v-col cols="3" class="px-1">
                          <v-text-field
                            v-model="inpt.inpt_tel2_oms"
                            label="Remark"
                            placeholder="."
                            dense
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col>
                          <v-checkbox dense label="No marketing" v-model="inpt.inpt_marketing_as_log"></v-checkbox>
                        </v-col>
                      </v-row>

                     

                      <v-row no-gutters>
                        <v-col cols="1" class="px-1">
                          <v-btn
                            class="primary ma-2"
                            :disabled="!inptCard1Valid"
                            small
                            @click="saveInptCard1"
                            >Save</v-btn
                          >
                        </v-col>                      
                      </v-row>
                    </v-form>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-form ref="inptCard3">
                      <v-card-title>Email addresses<v-spacer></v-spacer>
            
                        <v-btn class="primary ma-2" x-small @click="addInpe(inpt.inpt_encrid)">Add contact</v-btn> 
                      </v-card-title>

                      <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <td>Email</td>
                            <td>Name / Tel.</td>                            
                            <td>Invoice</td>
                            <td>Booking</td>
                            <td>Cancellation</td>
                            <td>Complaint</td>
                            <td>Tech</td>
                            <td>MyBooking</td>
                          </tr>  
                        </thead>  
                        <tbody>
                          <tr v-for="(inpeRecord,i) in inpt.inpe" :key="i">
                           <td class="mb-3">{{inpeRecord.inpe_email}}</td>
                           <td>{{inpeRecord.inpe_naam}}<br><v-icon small v-if="inpeRecord.inpe_telefoon!==''" class="mr-2">mdi-phone</v-icon>{{inpeRecord.inpe_telefoon}}</td>
                           <td style="justify-items: center;"><v-checkbox v-model="inpeRecord.inpe_ind_fact" @change="updInpe(inpeRecord)"></v-checkbox></td>
                           <td style="justify-items: center;"><v-checkbox v-model="inpeRecord.inpe_ind_boek" @change="updInpe(inpeRecord)"></v-checkbox></td>
                           <td style="justify-items: center;"><v-checkbox v-model="inpeRecord.inpe_ind_annulering" @change="updInpe(inpeRecord)"></v-checkbox></td>
                           <td style="justify-items: center;"><v-checkbox v-model="inpeRecord.inpe_ind_klacht" @change="updInpe(inpeRecord)"></v-checkbox></td>
                           <td style="justify-items: center;"><v-checkbox v-model="inpeRecord.inpe_ind_tech" @change="updInpe(inpeRecord)"></v-checkbox></td>
                           <td style="justify-items: center;"><v-checkbox v-model="inpeRecord.inpe_ind_login_mb" @change="updInpe(inpeRecord)"></v-checkbox></td>
                           <td style="justify-items: center;"><v-btn text icon small  @click="rmInpe(inpeRecord.inpe_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td>
                           <!--
                           <td><v-btn text icon  @click="updHsct2(hsctRecord.hsct_encrid)"><v-icon small>mdi-wrench</v-icon></v-btn></td>
                           <td><v-btn text icon  @click="updHsct(hsctRecord.hsct_encrid)"><v-icon small>mdi-bell</v-icon></v-btn></td>
                           <td><v-btn v-if="hsctRecord.rmHsct === 'Yes'" text icon  @click="rmHsct(hsctRecord.hsct_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td>
                           -->
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <addInpe ref="addInpe"></addInpe>
                    <rmInpe ref="rmInpe"></rmInpe>

                      
                    </v-form>
                  </v-card>
                </v-col>
              </v-row>

            </v-container>
          </v-col>

          <v-col cols="6" class="px-1">
            <!-- Rechts -->
            <v-container>
              <v-row>
                <v-col cols="12" class="px-1">

                  <v-card>
                    <v-form ref="inptCard2">
                      <v-card-title>Finance</v-card-title>

                       <v-row no-gutters>
                         <v-col cols="5" class="px-1">
                          <v-text-field
                            v-model="inpt.inpt_naam_officieel"
                            :rules="inpt_naamRules"
                            label="Official company name"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="3" class="px-1">
                          <v-select
                            v-model="inpt.inpt_prijs_verhoging"
                            :items="inpt_prijs_verhogingKeuzes"
                            item-value="nr"
                            item-text="desc"
                            menu-props="auto"
                            label="Price raise"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="2" class="px-1">
                         <v-text-field
                            v-model="inpt.inpt_cred_num"
                            label="Creditor nr"
                            dense
                            readonly
                          ></v-text-field>
                         </v-col>  
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="3" class="px-1">
                          <v-select
                            v-model="inpt.inpt_com"
                            :items="inpt_com_percKeuzes"
                            item-value="nr"
                            item-text="desc"
                            menu-props="auto"
                            label="Commission percentage"
                          ></v-select>
                        </v-col>
                        <v-col cols="5" class="px-1">
                          <v-select
                            v-model="inpt.inpt_fact"
                            :items="inpt_factKeuzes"
                            item-value="nr"
                            item-text="desc"
                            menu-props="auto"
                            label="Invoicing"
                          ></v-select>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="3" class="px-1">
                          <v-select
                            v-model="inpt.inpt_handling_verk"
                            :items="inpt_handl_verkKeuzes"
                            item-value="code"
                            item-text="desc"
                            menu-props="auto"
                            label="Guest handling done by VFY"
                          ></v-select>
                        </v-col>
                        <v-col cols="3" class="px-1">
                          <v-select
                            v-model="inpt.inpt_handling_payment_verk"
                            :items="inpt_handl_paymKeuzes"
                            item-value="code"
                            item-text="desc"
                            menu-props="auto"
                            label="Payment handling done by"
                          ></v-select>
                        </v-col>
                      </v-row>


                      <v-row no-gutters>
                        <v-col cols="3" class="px-1">
                          <v-text-field
                            v-model="inpt.inpt_iban"
                            label="IBAN"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="2" class="px-1">
                          <v-text-field
                            v-model="inpt.inpt_bic"
                            label="BIC"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="5" class="px-1">
                          <v-text-field
                            v-model="inpt.inpt_iban_naam"
                            label="Sales partner  name on bankaccount (only if different from name)"
                            dense
                          ></v-text-field>
                        </v-col>
                        
                      </v-row>
                      
                      <v-row no-gutters>
                        <v-col cols="3" class="px-1">
                          <v-select
                            v-model="inpt.inpt_btw_num_stat"
                            :items="inpt_btw_num_statKeuzes"
                            item-value="code"
                            item-text="desc"
                            menu-props="auto"
                            label="VAT applicable"
                          ></v-select>
                        </v-col>
                        <v-col cols="5" class="px-1">
                          <v-text-field
                            v-model="inpt.inpt_btw_num"
                            label="VAT number"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="4" class="px-1">
                          <v-text-field
                            v-model="inpt.inpt_kvk"
                            label="Chamber of Commerce ID"
                            dense
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="1" class="px-1">
                          <v-btn
                            class="primary ma-2"
                            :disabled="!inptCard1Valid"
                            small
                            @click="saveInptCard2"
                            >Save</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                  </v-col>
              </v-row>    
              <v-row>
                <v-col cols="12" class="px-1">
    

                  <v-card>
                    <v-form ref="inptCard3">
                      <v-card-title>Technical</v-card-title>

                       <v-row no-gutters>
                        <v-col cols="4" class="px-1">
                          <v-select
                            v-model="inpt.inpt_pbm"
                            :items="inpt_pbmKeuzes"
                            item-value="code"
                            item-text="desc"
                            menu-props="auto"
                            label="Primary booking method"
                          ></v-select>
                        </v-col>
                        <v-col cols="4" class="px-1">
                          <v-select
                            v-model="inpt.inpt_review_send"
                            :items="inpt_review_sendKeuzes"
                            item-value="code"
                            item-text="desc"
                            menu-props="auto"
                            label="Send review to guest"
                          ></v-select>
                        </v-col>
                      </v-row>

                      <v-row no-gutters>
                        <v-col cols="1" class="px-1">
                          <v-btn
                            class="primary ma-2"
                            :disabled="!inptCard1Valid"
                            small
                            @click="saveInptCard3"
                            >Save</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                </v-col>
              </v-row>

             
            </v-container>
          </v-col>
        </v-row>
      </v-container>
      <m_attm ref="m_attm"></m_attm>
      <nott ref="nott"></nott>
      <rmInpt ref="rmInpt"></rmInpt>
    </v-main>
    <!-- <navBar></navBar> -->
    
  </v-app>
</template>




<script>

import { bus } from "../../../main";

import m_attm from "@/components/m_attm.vue";
import nott from "@/components/nott.vue";
import rmInpt from "@/views/task/inpt/rmInpt.vue";
import addInpe from "@/views/task/inpt/inpe/addInpe.vue";
import iper from "@/views/task/inpt/iper.vue";
import rmInpe from "@/views/task/inpt/inpe/rmInpe.vue";
import inpt_type_select from '@/components/task/inpt/ui/inpt_type_select.vue';
import inpt_status_select from '@/components/task/inpt/ui/inpt_status_select.vue';
import defNavBar from '@/components/ui/navbars/navbar.vue';

export default {
  components: {
    m_attm,
    nott,
    rmInpt,
    addInpe,
    rmInpe,
    iper,
    inpt_type_select,
    inpt_status_select,
    defNavBar
  },
  props: ["inpt_encrid"],
  data() {
    return {
      inptCard1Valid: false,
      iperErrorsExist: false,
      iperWarningsExist: false,
      taal_codeKeuzes: [],
      land_codeKeuzes: [],
      inpt_btw_num_statKeuzes: [],
      inpt_handl_verkKeuzes: [],
      inpt_handl_paymKeuzes: [],
      inpt_com_percKeuzes: [],
      inpt_prijs_verhogingKeuzes: [],
      inpt_factKeuzes: [],
      inpt_pbmKeuzes: [],
      inpt_review_sendKeuzes: [],
      dat1menu: false,
      items: [],
      inpt: {
        action_items: [] /* moet pre defined ivm length check, nee hoor Array.IsArray() kun je dit mee afvangen */,
      },
      inpt_naamRules: [(v) => (v && v.length >= 3) || "A name is required"],
      inpt_passwdRules: [(v) => (v && v.length >= 8) || "A password is required"],
      inpt_emailRules: [
        (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/.test(v) ||
          "E-mail must be valid",
      ],
    };
  },
  created() {
    bus.$on("closeDialog", (data) => {
      console.log(data);
      if(data==='reload' || data==='attm_m_attm'){
        this.getInpt();
      }
    });  
    bus.$on("addNote", (data) => {
       console.log(data);
       this.inpt.nott_aant += data;
    });            
  },    
  mounted() {
    this.getInpt();
  },
  methods: {
    updateData(data){
      this.inpt[data.field] = data.value;
    },        
    getInpt(){
      var deze = this;
      this.$axios
        .post("ares/json/ares/task/inpt/getInpt2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getInpt",
          },
          getInpt: {
            inpt_encrid: this.inpt_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.inpt = res.data.getInpt;
            document.title = "Host " + res.data.getInpt.inpt_code;
            this.items = res.data.getInpt.huizen;
            res.data.getInpt.taal_codeKeuzes.forEach(function (taal) {
              deze.taal_codeKeuzes.push(taal);
            });
            res.data.getInpt.land_codeKeuzes.forEach(function (land) {
              deze.land_codeKeuzes.push(land);
              if (land.land_codeSelected === true) {
                deze.inpt.land_code = land.land_code;
              }
            });
            res.data.getInpt.inpt_factKeuzes.forEach(function (fact) {
              deze.inpt_factKeuzes.push(fact);
            });
            res.data.getInpt.inpt_pbmKeuzes.forEach(function (pbm) {
              deze.inpt_pbmKeuzes.push(pbm);
            });
            res.data.getInpt.inpt_review_sendKeuzes.forEach(function (review) {
              deze.inpt_review_sendKeuzes.push(review);
            });
            res.data.getInpt.inpt_prijs_verhogingKeuzes.forEach(function (prijs_verhoging) {
              deze.inpt_prijs_verhogingKeuzes.push(prijs_verhoging);
            });
            res.data.getInpt.inpt_com_percKeuzes.forEach(function (com_perc) {
              deze.inpt_com_percKeuzes.push(com_perc);
            });
            res.data.getInpt.inpt_btw_num_statKeuzes.forEach(function (btw) {
              deze.inpt_btw_num_statKeuzes.push(btw);
            });
            res.data.getInpt.inpt_handl_verkKeuzes.forEach(function (verk) {
              deze.inpt_handl_verkKeuzes.push(verk);
            });
            res.data.getInpt.inpt_handl_paymKeuzes.forEach(function (paym) {
              deze.inpt_handl_paymKeuzes.push(paym);
            });
            if(res.data.getInpt.iperNumberOfErrors > 0) this.iperErrorsExist = true;
            if(res.data.getInpt.iperNumberOfWarnings > 0) this.iperWarningsExist = true;
            console.log('inpt', this.inpt);
          }
        });      
    },
    saveInptCard1() {
      if (this.$refs.inptCard1.validate()) {

        this.$axios
          .post("ares/json/ares/task/inpt/saveInptCard1v3.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "saveInptCard1",
            },
            saveInptCard1: {
              inpt_encrid: this.inpt_encrid,
              inpt_naam: this.inpt.inpt_naam,
              inpt_passwd: this.inpt.inpt_passwd,
              taal_code: this.inpt.taal_code,
              inpt_adres: this.inpt.inpt_adres,
              inpt_postcode: this.inpt.inpt_postcode,
              inpt_plaats: this.inpt.inpt_plaats,
              land_code: this.inpt.land_code,
              inpt_tel1_vcs: this.inpt.inpt_tel1_vcs,
              inpt_tel1_oms: this.inpt.inpt_tel1_oms,
              inpt_tel2_vcs: this.inpt.inpt_tel2_vcs,
              inpt_tel2_oms: this.inpt.inpt_tel2_oms,
              inpt_type: this.inpt.inpt_type,
              inpt_status: this.inpt.inpt_status,
              inpt_marketing: this.inpt.inpt_marketing_as_log
            },
          })
          .then((res) => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: res.data.saveInptCard1.text,
                color: res.data.saveInptCard1.color,
              });
            }
          });
      }
    },
    saveInptCard2() {
      if (this.$refs.inptCard1.validate()) {
        this.$axios
          .post("ares/json/ares/task/inpt/saveInptCard2.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "saveInptCard2",
            },
            saveInptCard2: {
              inpt_encrid: this.inpt_encrid,
              inpt_naam_officieel: this.inpt.inpt_naam_officieel,
              inpt_iban: this.inpt.inpt_iban,
              inpt_bic: this.inpt.inpt_bic,
              inpt_iban_naam: this.inpt.inpt_iban_naam,
              inpt_kvk: this.inpt.inpt_kvk,
              inpt_handling_verk: this.inpt.inpt_handling_verk,
              inpt_fact: parseInt(this.inpt.inpt_fact),
              inpt_com: parseFloat(this.inpt.inpt_com),
              inpt_prijs_verhoging: parseInt(this.inpt.inpt_prijs_verhoging),
              inpt_handling_payment_verk: this.inpt.inpt_handling_payment_verk,
              inpt_btw_num_stat: this.inpt.inpt_btw_num_stat,
              inpt_btw_num: this.inpt.inpt_btw_num
            },
          })
          .then((res) => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              setTimeout(() => { this.$router.reload("/task/inpt/onInpt/" + res.data.saveInptCard2.inpt_encrid); opener.location.reload(); }, 2000); 
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: res.data.saveInptCard2.text,
                color: res.data.saveInptCard2.color,
              });
            }
          });
      }
    },
    saveInptCard3() {
      if (this.$refs.inptCard1.validate()) {
        this.$axios
          .post("ares/json/ares/task/inpt/saveInptCard3.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "saveInptCard3",
            },
            saveInptCard3: {
              inpt_encrid: this.inpt_encrid,
              inpt_pbm: this.inpt.inpt_pbm,
              inpt_review_send: this.inpt.inpt_review_send
            },
          })
          .then((res) => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              setTimeout(() => { this.$router.reload("/task/inpt/onInpt/" + res.data.saveInptCard3.inpt_encrid); opener.location.reload(); }, 2000); 
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: res.data.saveInptCard3.text,
                color: res.data.saveInptCard3.color,
              });
            }
          });
      }
    },
    getIper(iper_type) {
       this.$refs.iper.open('dummy', this.inpt.inpt_code, iper_type); 
    },
    updInpe(inpeRecord) { 
      this.$axios
        .post("ares/json/ares/task/inpt/inpe/updInpe2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updInpe"
          },
          updInpe: {
            inpe_encrid: inpeRecord.inpe_encrid,
            inpe_ind_fact: inpeRecord.inpe_ind_fact,
            inpe_ind_boek: inpeRecord.inpe_ind_boek,
            inpe_ind_annulering: inpeRecord.inpe_ind_annulering,
            inpe_ind_klacht: inpeRecord.inpe_ind_klacht,
            inpe_ind_tech: inpeRecord.inpe_ind_tech,
            inpe_ind_login_mb: inpeRecord.inpe_ind_login_mb
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updInpe.text,
              color: res.data.updInpe.color
            });
          }
        })
    },
    addInpe(inpt_encrid) {
       this.$refs.addInpe.open(inpt_encrid);
    },
    rmInpe(inpe_encrid) {
       this.$refs.rmInpe.open(inpe_encrid);
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    actionClick(action) {
      switch (action) {
        case "rmInpt":
          this.$refs.rmInpt.open(this.inpt_encrid);
          break;
        case "nott": 
          this.$refs.nott.open("inpt", this.inpt_encrid, "all"); 
          break;
        case "m_attm": 
          this.$refs.m_attm.open('inpt', this.inpt.inpt_code, '', 'inpt', this.inpt_encrid, 0); 
          break;          
      }
    },
    dumpToConsole(){
        console.log('inpt type', this.inpt_type);
    },
    loginInfo(inpt_encrid) {
      window.open("https://partner.villaforyou.biz/loginFromAres/" + inpt_encrid);
    },
  },
};
</script> 
